import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useMap } from "react-map-gl";
import { toast } from "react-toastify";
import { useMapStore } from "../..";
import { ILayerWithAbilityToOverrideIsStyleLoadedProps } from "../../interfaces/IlayerProps";

function PointsOfInterestMapLayer({ visible, isStyleLoadedOverride }: ILayerWithAbilityToOverrideIsStyleLoadedProps) {
    const map = useMap().current!;
    const mapStore = useMapStore();

    useEffect(() => {
        if (isStyleLoadedOverride ?? mapStore.isStyleLoaded) {
            try {
                map.setConfigProperty("basemap", "showPointOfInterestLabels", visible);
            } catch {
                toast.error("The current map style doesn't include all required config properties");
            }
        }
    }, [mapStore.isStyleLoaded, isStyleLoadedOverride, visible]);

    return (
        <></>
    );
}

export default observer(PointsOfInterestMapLayer);